import styled from 'styled-components';

export default styled.div`
  .ant-table-row {
    .ant-table-row-expand-icon-cell {
      display: none;
    }
  }
  .ant-table-wrapper {
    margin: 0 !important;
  }

  .ant-table-tbody > tr > td {
    padding: 3.5px 12px !important;
    color: ${({ theme }) => theme.colors.grayPrimary} !important;
    border-bottom: none !important;
  }
  .ant-table-tbody > tr > td:nth-child(n + 2) {
    text-align: right;
  }
  .ant-table-cell-with-append {
    display: flex;
    align-items: center;
    svg:hover {
      cursor: pointer;
    }
  }

  //Operating Expenses
  .ant-table-row[data-row-key='13-1'] > td:first-child > span {
    margin-right: 13px !important;
  }
  .ant-table-row[data-row-key='13-1'] > td:first-child::before {
    content: '';
    display: block;
    position: absolute;
    top: 2px;
    left: 18px;
    width: 17px;
    height: 24px;
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.grayDark} 0%,
      ${({ theme }) => theme.colors.grayDark} 1px,
      transparent 1px,
      transparent 16px,
      ${({ theme }) => theme.colors.grayDark} 16px,
      ${({ theme }) => theme.colors.grayDark} 17px
    );
  }
  .ant-table-row[data-row-key='13-1'] > td:first-child::after {
    display: block;
    position: absolute;
    top: 14px;
    left: 22px;
    width: 12px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.grayDark};
  }
  .ant-table-row[data-row-key='13-2'] > td:first-child > span {
    margin-right: 13px !important;
  }
  .ant-table-row[data-row-key='13-2'] > td:first-child::before {
    content: '';
    display: block;
    position: absolute;
    top: 2px;
    left: 18px;
    width: 17px;
    height: 24px;
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.grayDark} 0%,
      ${({ theme }) => theme.colors.grayDark} 1px,
      transparent 1px,
      transparent 16px,
      ${({ theme }) => theme.colors.grayDark} 16px,
      ${({ theme }) => theme.colors.grayDark} 17px
    );
  }
  .ant-table-row[data-row-key='13-2'] > td:first-child::after {
    display: block;
    position: absolute;
    top: 14px;
    left: 22px;
    width: 12px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.grayDark};
  }
  .ant-table-row[data-row-key='13-3'] > td:first-child > span {
    margin-right: 13px !important;
  }
  .ant-table-row[data-row-key='13-3'] > td:first-child::before {
    content: '';
    display: block;
    position: absolute;
    top: 2px;
    left: 18px;
    width: 17px;
    height: 12px;
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.grayDark} 0%,
      ${({ theme }) => theme.colors.grayDark} 1px,
      transparent 1px,
      transparent 16px,
      ${({ theme }) => theme.colors.grayDark} 16px,
      ${({ theme }) => theme.colors.grayDark} 17px
    );
  }
  .ant-table-row[data-row-key='13-3'] > td:first-child::after {
    display: block;
    position: absolute;
    top: 14px;
    left: 22px;
    width: 12px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.grayDark};
  }
  .ant-table-row[data-row-key='5-4'] > td:first-child > span {
    margin-right: 13px !important;
  }
  .ant-table-row[data-row-key='5-4'] > td:first-child::before {
    content: '';
    display: block;
    position: absolute;
    top: 2px;
    left: 18px;
    width: 17px;
    height: 24px;
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.grayDark} 0%,
      ${({ theme }) => theme.colors.grayDark} 1px,
      transparent 1px,
      transparent 16px,
      ${({ theme }) => theme.colors.grayDark} 16px,
      ${({ theme }) => theme.colors.grayDark} 17px
    );
  }
  .ant-table-row[data-row-key='5-4'] > td:first-child::after {
    display: block;
    position: absolute;
    top: 14px;
    left: 22px;
    width: 12px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.grayDark};
  }
  .ant-table-row[data-row-key='5-5'] > td:first-child > span {
    margin-right: 13px !important;
  }
  .ant-table-row[data-row-key='5-5'] > td:first-child > span {
    margin-right: 13px !important;
  }
  .ant-table-row[data-row-key='5-5'] > td:first-child::before {
    content: '';
    display: block;
    position: absolute;
    top: 2px;
    left: 18px;
    width: 17px;
    height: 12.5px;
    background: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.grayDark} 0%,
      ${({ theme }) => theme.colors.grayDark} 1px,
      transparent 1px,
      transparent 16px,
      ${({ theme }) => theme.colors.grayDark} 16px,
      ${({ theme }) => theme.colors.grayDark} 17px
    );
  }
  .ant-table-row[data-row-key='5-5'] > td:first-child::after {
    display: block;
    position: absolute;
    top: 14px;
    left: 22px;
    width: 12px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.grayDark};
  }

  .ant-table-row[data-row-key='1'] > td:first-child > span,
  .ant-table-row[data-row-key='2'] > td:first-child > span,
  .ant-table-row[data-row-key='3'] > td:first-child > span,
  .ant-table-row[data-row-key='4'] > td:first-child > span,
  .ant-table-row[data-row-key='5'] > td:first-child > span,
  .ant-table-row[data-row-key='7'] > td:first-child > span,
  .ant-table-row[data-row-key='8'] > td:first-child > span,
  .ant-table-row[data-row-key='10'] > td:first-child > span,
  .ant-table-row[data-row-key='11'] > td:first-child > span,
  .ant-table-row[data-row-key='12'] > td:first-child > span,
  .ant-table-row[data-row-key='14'] > td:first-child > span,
  .ant-table-row[data-row-key='9'] > td:first-child > span {
    margin-right: 0px !important;
  }

  .ant-table-row[data-row-key='4'],
  .ant-table-row[data-row-key='9'],
  .ant-table-row[data-row-key='12'],
  .ant-table-row[data-row-key='7'] {
    background-color: ${({ theme }) => theme.colors.blueLightest} !important;
  }
  .ant-table-row[data-row-key='4'] > td,
  .ant-table-row[data-row-key='9'] > td,
  .ant-table-row[data-row-key='7'] > td {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayPrimary} !important;
  }
  .ant-table-row[data-row-key='4'] > td:first-child,
  .ant-table-row[data-row-key='9'] > td:first-child,
  .ant-table-row[data-row-key='7'] > td:first-child,
  .ant-table-row[data-row-key='12'] > td:first-child {
    font-weight: 700 !important;
  }

  .ant-table-row[data-row-key='12'] > td {
    border-top: 1px solid ${({ theme }) => theme.colors.grayPrimary} !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayPrimary} !important;
  }
  .ant-table-wrapper
    .ant-table-container
    table
    > tbody
    > tr:last-child
    > *:last-child {
    border-end-end-radius: 0px !important;
  }
  .ant-table-wrapper
    .ant-table-container
    table
    > tbody
    > tr:last-child
    > *:first-child {
    border-end-start-radius: 0px !important;
  }
  .ant-table-row-expand-icon {
    margin-right: 8px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .ant-table-expanded-row {
    position: relative;
  }

  .ant-table-row[data-row-key='1'] > td:first-child,
  .ant-table-row[data-row-key='2'] > td:first-child,
  .ant-table-row[data-row-key='3'] > td:first-child,
  .ant-table-row[data-row-key='5'] > td:first-child,
  .ant-table-row[data-row-key='13'] > td:first-child,
  .ant-table-row[data-row-key='13-1'] > td:first-child,
  .ant-table-row[data-row-key='13-2'] > td:first-child,
  .ant-table-row[data-row-key='13-3'] > td:first-child,
  .ant-table-row[data-row-key='5-4'] > td:first-child,
  .ant-table-row[data-row-key='5-5'] > td:first-child,
  .ant-table-row[data-row-key='6'] > td:first-child,
  .ant-table-row[data-row-key='7'] > td:first-child,
  .ant-table-row[data-row-key='8'] > td:first-child,
  .ant-table-row[data-row-key='9'] > td:first-child,
  .ant-table-row[data-row-key='10'] > td:first-child,
  .ant-table-row[data-row-key='14'] > td:first-child,
  .ant-table-row[data-row-key='11'] > td:first-child {
    background-color: ${({ theme }) => theme.colors.light} !important;
  }

  .ant-table-row[data-row-key='4'] > td:first-child,
  .ant-table-row[data-row-key='7'] > td:first-child,
  .ant-table-row[data-row-key='12'] > td:first-child,
  .ant-table-row[data-row-key='9'] > td:first-child {
    background-color: ${({ theme }) => theme.colors.blueLightest} !important;
  }

  .ant-table-measure-row {
    display: none;
  }
`;
